import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { ModalController, IonicModule } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { AccountRepositoryService } from "src/app/pages/account/account-repository.service";
import { SyndicateTicketsComponent } from "src/app/pages/syndicate/syndicate-tickets/syndicate-tickets.component";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";

@Component({
    selector: "app-reg-profile-dialog-component",
    templateUrl: "./reg-profile-dialog-component.component.html",
    styleUrls: ["./reg-profile-dialog-component.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class RegProfileDialogComponentComponent implements OnInit {
  selectedId: number = null;
  timer$;
  sub = new Subscription();
  progress: number;
  showSpinner: boolean = false;
  showTicket = false;
  isSalesJourney = false;
  isCashPurchase = false;
  isAddCardCashPurchase = false;
  public selectedLanguage: string;
  private modalFailed = false;
  private digitOneThousand = 1000;

  constructor(
    private matDialogRef: MatDialogRef<RegProfileDialogComponentComponent>,
    private GTMSegment: GTMSegmentService,
    private router: Router,
    private snackService: MySnackBarService,
    private snackBar: MatSnackBar,
    private accountService: AccountRepositoryService,
    private modalController: ModalController,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    private authService: AuthService
  ) {
    this.authService.selectedlanguage$.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
    this.GTMSegment.GTMPopupInitialization("DeclineInvitaion");
  }

  ngOnInit() {
    let desc = "";
  }

  onReveal(selectedId: number) {
    this.selectedId = selectedId;
  }

  goToSyndicate() {
    this.matDialogRef.close(true);
    if (localStorage.getItem("sjFlow")) {
      const sjFlow = localStorage.getItem("sjFlow");
      localStorage.removeItem("sjFlow");
      this.isSalesJourney = true;
      if (sjFlow === "addCard") {
        this.isAddCardCashPurchase = true;
      }
    }
    if (localStorage.getItem("payType")) {
      const payType = localStorage.getItem("payType");
      localStorage.removeItem("payType");
      this.isCashPurchase = payType === "cash";
      this.isAddCardCashPurchase = payType === "add card";
    }
    this.createModalAndHandleError();
  }

  private createModalAndHandleError(): void {
    this.authService.commonUserCheck(() => {
      this.showTicketModal().catch((err) => {
        //  in case of modal generation failure, create a modal once again before redirecting user to 'syndicate' tab
        if(!this.modalFailed) {
          this.modalFailed = true;
          setTimeout(() => {
            this.createModalAndHandleError();
          }, this.digitOneThousand);
        } else {
          this.modalController.dismiss();
          this.router.navigate(["mainTabs/tabs/syndicate"]);
          return "Error in creating syndicate-ticket modal:" + err;
        }
      });
    })
  }

  async showTicketModal(): Promise<void> {
    const syndicateTickets = await this.modalController.create({
      component: SyndicateTicketsComponent,
      componentProps: {
        syndicate: {},
        isSalesJourney: this.isSalesJourney,
        isCashPurchase: this.isCashPurchase,
        isAddCardCashPurchase: this.isAddCardCashPurchase,
      },
      cssClass: "modal-fullScreen",
    });

    return await syndicateTickets.present();
  }
}
